import { type ServiceContainer } from './service-container.ts';

export enum Scope {
  Factory = 'Factory',
  Singleton = 'Singleton'
}

export type FactoryFunction<Bindings extends BindingsMap, T> = (
  container: ServiceContainer<Bindings>
) => T;
export type BindingKey = string;
export type BindingsMap = Record<BindingKey, object>;
